export const DEFAULT_PROPERTY_TYPES = ['House', 'Apartment', 'Flat', 'Room']
export const DEFAULT_MIN_BEDROOMS = 1
export const DEFAULT_MAX_BEDROOMS = 6
export const DEFAULT_BEDROOM_MARKS = {1: '1', 2: '2', 3: '3', 4: '4', 5: '5', 6: '6+'}